import {
  CurrencyCode,
  WeightUnit,
} from "@redotech/shopify-client/storefront.graphql";
import { GetCollectionProductsPaginatedQuery } from "../shopify-storefront.graphql";

export const mockGetCollectionProductsPaginatedQueryResponse: GetCollectionProductsPaginatedQuery =
  {
    collection: {
      products: {
        nodes: [
          {
            id: "gid://shopify/Product/1234567890",
            title: "Test Product",
            tags: ["test", "product"],
            productType: "Test Product",
            options: [],
            featuredImage: { url: "https://via.placeholder.com/150" },
            variants: {
              nodes: [
                {
                  id: "gid://shopify/ProductVariant/1234567890",
                  title: "Test Variant",
                  weight: 100,
                  weightUnit: WeightUnit.Grams,
                  sku: "TEST-123",
                  quantityAvailable: 100,
                  price: { amount: "100", currencyCode: CurrencyCode.Usd },
                  image: { url: "https://via.placeholder.com/150" },
                  selectedOptions: [],
                },
              ],
            },
            collections: { nodes: [] },
          },
        ],
        pageInfo: { endCursor: undefined, hasNextPage: false },
      },
    },
  };
